import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row my-2 justify-content-sm-center justify-content-md-end" }
const _hoisted_3 = { class: "wrap-text" }
const _hoisted_4 = { class: "wrap-text" }
const _hoisted_5 = { class: "m-1 col-10 col-md-3 zip-download-button-wrap p-0" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "wrap-text" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row justify-content-between mb-2 content-center" }
const _hoisted_10 = { class: "col-md-4 col-sm" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col staff-table-wrap container" }
const _hoisted_13 = { class: "table" }
const _hoisted_14 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_ClearableInput = _resolveComponent("ClearableInput")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_PopupMenu = _resolveComponent("PopupMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumbs, {
      here: _ctx.branchName,
      ancestries: _ctx.ancestries
    }, null, 8, ["here", "ancestries"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "m-1 col-10 col-md-3 btn btn-info",
        style: _normalizeStyle({'font-size': _ctx.FontSizes.normal}),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickBranchApprovalList && _ctx.onClickBranchApprovalList(...args)))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.branchName) + "支店の請求承認メッセージ一覧", 1)
      ], 4),
      _createElementVNode("button", {
        class: "m-1 col-10 col-md-3 btn btn-info",
        style: _normalizeStyle({'font-size': _ctx.FontSizes.normal}),
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickBranchDiffList && _ctx.onClickBranchDiffList(...args)))
      }, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.branchName) + "支店のデータ差分概要", 1)
      ], 4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-info zip-download-button",
          style: _normalizeStyle({'font-size': _ctx.FontSizes.normal}),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClickDownloadBranchInvoicePDFZip && _ctx.onClickDownloadBranchInvoicePDFZip(...args))),
          disabled: !_ctx.canClickDownloadZipButton()
        }, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.downloadZipButtonText()), 1)
        ], 12, _hoisted_6),
        _withDirectives(_createElementVNode("div", {
          class: "dl-progress-bar bg-info",
          style: _normalizeStyle({width: _ctx.progressWidth()})
        }, null, 4), [
          [_vShow, _ctx.downloadingState === _ctx.zipDownloadState.DOWNLOADING]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large1})
      }, _toDisplayString(_ctx.branchName) + "支店のスタッフ一覧", 5)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_ClearableInput, {
          text: _ctx.searchText,
          "onUpdate:text": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText) = $event))
        }, null, 8, ["text"])
      ]),
      _withDirectives(_createElementVNode("select", {
        class: "option-select col-md-3 col-4 align-self-center",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.activeFlag) = $event))
      }, [...(_cache[5] || (_cache[5] = [
        _createElementVNode("option", { value: "0" }, "全アクティブユーザー", -1),
        _createElementVNode("option", { value: "1" }, "未登録ユーザー", -1),
        _createElementVNode("option", { value: "2" }, "登録済ユーザー", -1)
      ]))], 512), [
        [_vModelSelect, _ctx.activeFlag]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _cache[6] || (_cache[6] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "社員番号"),
              _createElementVNode("th", null, "名前"),
              _createElementVNode("th"),
              _createElementVNode("th")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchedStaffs, (staff) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: staff.vForKey
              }, [
                _createElementVNode("td", null, _toDisplayString(staff.staffId), 1),
                _createElementVNode("td", null, _toDisplayString(staff.displayName), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-info",
                    style: _normalizeStyle({'font-size': _ctx.FontSizes.normal}),
                    onClick: ($event: any) => (_ctx.onClickStaffDetail(staff.staffId))
                  }, "スタッフ詳細へ", 12, _hoisted_14)
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_MenuButton, {
                    data: staff,
                    "on-click": _ctx.onClickStaffMenu,
                    "key-as-id": staff.vForKey
                  }, null, 8, ["data", "on-click", "key-as-id"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(_component_PopupMenu, {
      show: _ctx.showStaffMenuPopup,
      hide: _ctx.hideStaffMenuPopup,
      position: _ctx.staffMenuPopupPos,
      items: _ctx.staffMenuItems
    }, null, 8, ["show", "hide", "position", "items"])
  ]))
}